<!--
 * @Author: wangjiaxiang
 * @Date: 2022-04-13 11:02:24
 * @LastEditTime: 2022-04-24 13:57:19
 * @LastEditors: wangjiaxiang
 * @Description: 
 * @FilePath: /xingmahui_front/src/views/contents/expertsView/components/signUpTips.vue
 * 
-->
<template>
  <div v-if="isShow" class="wrapper" @touchmove.prevent @mousewheel.prevent>
    <div class="content">
      <div class="bg-img">
        <p>预约成功！</p>
        <p>
          本课程将于<span>{{ returnDate(startTime) }}</span
          >开课，我们将会在开课前30分钟提醒您，请您注意相关消息。
        </p>
        <div @click="closeJupm">查看更多课程</div>
      </div>
      <img
        @click="close"
        class="close"
        src="@/assets/images/expertsView/close.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["startTime", "isShow"],
  data() {
    return {};
  },
  watch: {},
  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {
    close() {
      this.$emit("update:isShow", false);
    },
    closeJupm(){
      this.$emit("update:isShow", false);
      this.$router.push("/course")
    },
    returnDate: function(date) {
      date = new Date(Date.parse(date.replace(/-/g, "/")));
      var month = new Date(date).getMonth() + 1;
      var day = new Date(date).getDate();
      var weekday = new Array(7);
      weekday[0] = "星期日";
      weekday[1] = "星期一";
      weekday[2] = "星期二";
      weekday[3] = "星期三";
      weekday[4] = "星期四";
      weekday[5] = "星期五";
      weekday[6] = "星期六";
      var week = weekday[new Date(date).getDay()];
      var hours = new Date(date).getHours();
      if (hours < 10) hours = "0" + hours;
      var minute = new Date(date).getMinutes();
      if (minute < 10) minute = "0" + minute;
      //   return month + "月" + day + "日 " + week + " " + hours + ":" + minute;
      return month + "月" + day + "日" + hours + ":" + minute;
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  .content {
    text-align: center;
    width: 290px;
    height: 402px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    // background: red;
    .bg-img {
      overflow: hidden;
      padding: 0 24px;
      box-sizing: border-box;
      width: 100%;
      height: 348px;
      background-image: url("../../../../assets/images/expertsView/sing-up-tips.png");
      background-size: 100% 100%;
      p:nth-of-type(1) {
        margin-top: 152px;
        font-size: 20px;
        font-weight: bold;
      }
      p:nth-of-type(2) {
        color: #666666;
        margin-top: 10px;
        font-size: 16px;
        span {
          color: #333333;
          font-weight: bold;
        }
      }
      div {
        margin-top: 14px;
        width: 244px;
        height: 50px;
        background: linear-gradient(270deg, #f0ba3b 0%, #fed479 100%);
        box-shadow: 0px 4px 8px 0px rgba(231, 170, 28, 0.3);
        border-radius: 25px;
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
        line-height: 50px;
      }
    }
    .close {
      margin-top: 30px;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
